export default {"src":"/_next/static/media/rocket.c80fb88e.svg","height":172,"width":365,"blurWidth":0,"blurHeight":0};